 
import _ from "lodash";
import Guard from "../common/guard";
import { IUserEndPoint, IGetUserEndPoint } from "../models/applicationState";
import {  allModelsEndPoint, deleteModelEndPoint, accessToken, refreshTokenEndPoint, refreshTokenCall} from "../common/api-config";
import ServiceHelper from "./serviceHelper";
import { AppError, ErrorCode } from "../models/applicationState";
import { toast } from "react-toastify";
export interface IUserModelService {
    getUserModels(): Promise<void>;
    deleteUserModel(model): Promise<void>;
}

export default class ModelService implements IUserModelService {
    /**
     * Get all models
     */
    public getUserModels = async () => {
        let response;
        const headers = accessToken();
        try {
            response = await ServiceHelper.getWithAutoRetry(
                allModelsEndPoint(), { headers });
            return response.data;
        } catch (err) {
            let response;
            if(err.response.status == 401){
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if(response.data.status == 200){
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            allModelsEndPoint(), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            }else{
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /**
     * Delete Model
     */
    public deleteUserModel = async (model: any) => {
        let response;
        const headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                deleteModelEndPoint(model), { headers });
            return response.data;
        } catch (err) {
            let response;
            if(err.response.status == 401){
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if(response.data.status == 200){
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            deleteModelEndPoint(model), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }
                }
            }else{
                ServiceHelper.handleServiceError(err);
            }
        }
    }
}
